import React, { Component } from 'react';
import { connect } from 'react-redux'

import { s3StaticPath } from 'helper/helperFunctions';
import Validator from 'simple-react-validator'
import musicadjudicator_email from '../../assets/musicadjudicator_email.svg';
import { emailTemplatesService } from '../../services/emailTemplates';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      full_name: '',
      phone: '',
      email: '',
      message: '',
      company: ''
    };
    this.contactValidator = new Validator();
  }


  inputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  submitContactForm = () => {
    if (this.contactValidator.allValid()) {
      const data = {
        full_name: this.state.full_name,
        phone: this.state.phone,
        email: this.state.email,
        message: this.state.message,
        company: this.state.company
      }
      emailTemplatesService.sendContactEmail(data).then(
        res => {
          this.handleSuccess(res.message);
          const reset = {
            full_name: '',
            phone: '',
            email: '',
            message: '',
            company: ''
          }
          this.setState(prevState => ({
            ...prevState,
            ...reset
          }), () => {
            this.contactValidator.hideMessages();
            this.contactValidator.purgeFields();
            this.forceUpdate();
          })
        },
        err => {

        }
      );
    } else {
      this.contactValidator.showMessages();
      this.forceUpdate();
    }
  }
  handleSuccess = (message) => {
          toast.success(message, {
            position: "bottom-right",
            autoClose: 5000, // Auto close after 5 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light", // You can also use "dark"
          });
      }
  render() {

    return (
      <React.Fragment>

        <section id="contactUs" className="section-c">
          <ToastContainer />
          <h2 className="panel_heading">Contact Us</h2>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <p className="text_22 text-center mt-md">Do you have a question or need assistance with a Music Adjudicator Product or Service?</p>
              </div>

              <div className="col-md-6 mt-xlg">
                <div className="row">
                  <div className="col-md-6 mt-xlg">
                    <div className="supportBox text-center">
                      <img src={s3StaticPath('img/tour_operator_support.png')} alt="" />

                      <p className="text_16 mt-xlg"><strong className="semibold">Contact Details</strong></p>
                      <p style={{ letterSpacing: '0.5px' }} className="text_14 mt-xs"><img src={musicadjudicator_email} alt="email" /></p>
                      <p className="text_18 mt-xs">704-846-7870 ext. 205</p>
                      <p className="text_18 mt-xs">8300 Fairview Rd. Charlotte NC 28227</p>
                      <p className="text-primary mt-xs">(EST Hours: 9:00AM - 5:00PM)</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-xlg contactFormContainer">
                <div className="flexElem respFlex">
                  <div className="hasFieldIcon">
                    <span className="fieldIcon userIcon">&nbsp;</span>
                    <input onChange={this.inputChange} value={this.state.full_name} type="text" name='full_name' className="form-control" placeholder="Full Name" />
                    {this.contactValidator.message('full_name', this.state.full_name, 'required')}
                  </div>
                  <div className="hasFieldIcon">
                    <span className="fieldIcon companyIcon">&nbsp;</span>
                    <input onChange={this.inputChange} value={this.state.company} name='company' type="text" className="form-control" placeholder="Company" />
                    {this.contactValidator.message('company', this.state.company, 'required')}
                  </div>
                </div>

                <div className="flexElem respFlex">
                  <div className="hasFieldIcon">
                    <span className="fieldIcon emailIcon">&nbsp;</span>
                    <input onChange={this.inputChange} value={this.state.email} name='email' type="email" className="form-control" placeholder="Email" />
                    {this.contactValidator.message('email', this.state.email, 'required|email')}
                  </div>
                  <div className="hasFieldIcon">
                    <span className="fieldIcon userIcon">&nbsp;</span>
                    <input onChange={this.inputChange} value={this.state.phone} name='phone' type="text" className="form-control" placeholder="Phone" />
                    {this.contactValidator.message('phone', this.state.phone, 'required|phone')}
                  </div>
                </div>

                <div className="flexElem block respFlex">
                  <div><textarea name='message' value={this.state.message} onChange={this.inputChange} className="form-control" placeholder="Message"></textarea></div>
                </div>
                {this.contactValidator.message('message', this.state.message, 'required')}

                <div className="flexElem block respFlex">
                  <div className="text-center">
                    <button onClick={this.submitContactForm} type="button" className="themeBtn_14 no_radius hover_dark red_gradient">Submit Contact Form</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </React.Fragment>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
  }
}
export default connect(null, mapDispatchToProps)(ContactUs);



// WEBPACK FOOTER //
// ./src/components/FrontEnd/ContactUs.jsx